import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
// Initialize Firebase Messaging
const messaging = getMessaging(app);
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

// Request Permission for Notifications
const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      console.log("Notification permission granted.");
      // Get FCM Token
      const device_token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY
      });
      if (device_token) {
        localStorage.setItem("device_token", device_token);
        return device_token;
      } else {
        console.log("No registration token available.");
      }
    } else {
      console.log("Notification permission denied.");
    }
  } catch (error) {
    console.error("Error requesting notification permission:", error);
  }
};
// Handle Incoming Messages
// onMessage(messaging, (payload) => {
//     // You can show notifications here
// });
let emergencyMessageHandler = null;

export const setupForegroundMessageHandler = (onEmergencyMessage) => {
  emergencyMessageHandler = onEmergencyMessage;
};
onMessage(messaging, (payload) => {
  const { title, body } = payload.notification || {};
  const { position, type } = payload.data || {};

  // Show browser notification
  if (Notification.permission === "granted") {
    try {
      new Notification(title || "New Notification", {
        body: body,
        icon: "/favicon1.ico",
      });
    } catch (err) {
      console.error("Notification error:", err);
    }
  } else if (Notification.permission !== "denied") {
    Notification.requestPermission().then(permission => {
      if (permission === "granted") {
        try {
          new Notification(title || "New Notification", {
            body: body,
            icon: "/favicon1.ico",
          });
        } catch (err) {
          console.error("Notification error after requesting permission:", err);
        }
      }
    });
  }

  // Show emergency modal if appropriate
  if (
    (type === "Emergency Alert" || type === "Downtime Alert") &&
    typeof emergencyMessageHandler === 'function'
  ) {
    emergencyMessageHandler({ title, body, position });
  }
});


export const requestForToken = async () => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY
    });

    if (currentToken) {
      console.log("✅ FCM Token:", currentToken);
      return currentToken;
    } else {
      console.warn("⚠️ No registration token available. Request permission to generate one.");
      return null;
    }
  } catch (err) {
    console.error("❌ Error retrieving FCM token:", err);
    return null;
  }
};

//place the key in .env
// Register Service Worker
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("Service Worker registered:", registration);
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });
}
export { messaging, requestNotificationPermission, auth, googleProvider, signInWithPopup, signOut };